import Vue from 'vue'
import router from './router'
import App from './App.vue'
import dataV from '@jiaminghi/data-view'
import "@/components/cuscom/index.scss";
import Col from 'vant/lib/col';
import Row from 'vant/lib/row';
import { Checkbox, CheckboxGroup } from 'vant';
import NoticeBar from 'vant/lib/notice-bar';
import Swipe from 'vant/lib/swipe';
import SwipeItem from 'vant/lib/swipe-item';
import Progress from 'vant/lib/progress';
import 'vant/lib/row/style';
import 'vant/lib/checkbox/style';
import 'vant/lib/checkbox-group/style';
import 'vant/lib/progress/style';
import 'vant/lib/col/style';
import 'vant/lib/notice-bar/style';
import 'vant/lib/swipe/style';
import apis from "@/api/new";
import mobile from "@/views/platm/common/mobile.vue";
import Vconsole from 'vconsole'
import {SCREENTYPE} from './config/index'
// new Vconsole();
import 'babel-polyfill';
import Es6Promise from 'es6-promise'
import './common/pub.css'
import storage from 'good-storage'
import {isLogin} from '@/api/common.js'
import toastRegistry from './toast/index'
import 'amfe-flexible'
import './utils/rem'
Es6Promise.polyfill();
Vue.component('mobile',mobile)
Vue.config.productionTip = false
Vue.use(dataV).use(Col).use(Row).use(NoticeBar).use(Swipe).use(SwipeItem).use(Progress).use(Checkbox).use(CheckboxGroup);
Vue.prototype.$apis = apis;

const isPc=(()=> {
  let isPc=true;
  
  if(/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)) {
    //说明是移动端
    isPc=false;
  } 
  
  return isPc;
})();

function _isMobile(params) {
  const screenWidth=document.body.clientWidth;
  let device='pc'      
  if(!isPc){
    if(1400<screenWidth){    
      device='ipad'
    }else if(screenWidth<=1400){
      device='phone'      
    }  
  } 
  return device
}
console.log(_isMobile())
Vue.prototype.$toThousands = (val) => {
  if(val != undefined && val != null && val != ''){
      let value = ''
      let _arr = String(val).split('.')
      if(_arr && _arr.length!=0){
          let _val = _arr[0]//小数点前面的数
          let result = ''
          let counter = 0
          for(let i = _val.length-1;i>=0;i--){
              counter++
              result = _val.charAt(i) + result
              if (!(counter % 3) && i != 0) {
                  if (_val.charAt(i - 1) != '-') {
                    result = ',' + result
                  }
              }
          }
          value = result
      }
      value = value
      return value
  }else{
      return ''
  }
}
Vue.prototype.$isMobile= _isMobile

Vue.prototype.chartFontSize=(()=>{
  const screenWidth=document.body.clientWidth;
  let fs=16
  if(_isMobile()!="phone"){
    if(screenWidth<1400){    
      fs=14
    }else{
      fs=18
    } 
  }
  return fs
})()
Vue.prototype.barWidth=(()=>{
  const screenWidth=document.body.clientWidth;
  let bw=14
  if(_isMobile()!="phone"){
    if(screenWidth<1400){    
      bw=8
    }else{
      bw=12
    } 
  }
  return bw
})()
Vue.prototype.pieBottom=(()=>{
  const screenWidth=document.body.clientWidth;
  let bt=14
  if(_isMobile()!="phone"){
    if(screenWidth<1400){    
      bt=8
    }else{
      bt=40
    } 
  }else{
    bt=10
  }
  return bt
})()
Vue.prototype.pieTop=(()=>{
  const screenWidth=document.body.clientWidth;
  let bt=14
  if(_isMobile()!="phone"){
    if(screenWidth<1400){    
      bt=30
    }else{
      bt=50
    } 
  }else{
    bt=0
  }
  return bt
})()

/* --------------------------start-------------------------------- */
// 路由守卫 
router.beforeEach((to,from,next)=>{
	// console.log(to);
  let flag = isLogin(); 
	if(!flag){     // 获取不到登录信息
    if(to.name=='login'){
       next();
    }else{
       next('/login')
    }
		
	}
  else{  
		if(to.meta.roles && to.meta.roles.length>0){ // 需要登录权限进入的路由		
			if(checkRouter(to.meta.roles)){
				if(to.name=='login'){
          next({name:'main',replace:true})
        }else{
          next();
        }		
			}else{
        next("/login")
      }		
		}else{       // 不需要登录权限的路由直接进行下一步
			if(to.name=='login'){
        next({name:'main',replace:true})
      }else{
        next();
      }		
		}
	}
})
function checkRouter(roles){
	console.log("判断")
	var permiss = JSON.parse(localStorage.getItem('permiss'))
	if(permiss){
		for(var i=0;i<permiss.length;i++){
			for(var j=0;j<roles.length;j++){
				if(roles[j] == permiss[i].perms){
					return true;
				}
			}
		}
	}
	return false;
}

Vue.use(toastRegistry)
/* --------------------------end-------------------------------- */
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
